<template>
    <x-modal :id="id" :title="modalTitle" @shown="handleModalShown">
        <x-table :headers="[
            'Nama',
            'Email',
            'Alamat',
            'Foto',
        ]" :is-loading="isLoading">
            <tr v-for="(user, index) in users" :key="index" v-show="!isLoading">
                <td class="nowrap">{{ user.name }}</td>
                <td class="nowrap">{{ user.email }}</td>
                <td class="nowrap">
                    <div v-html="$options.filters.nl2br(user.address)" />
                </td>
                <td>
                    <img :src="user.image_url" class="img-responsive" style="max-height:100px" />
                </td>
            </tr>
        </x-table>

        <x-dumb-pagination v-if="shouldRenderPagination" :pagination="meta" @navigate="paginate" />

        <template #footer>
            <x-close-modal-button />
        </template>
    </x-modal>
</template>

<script>
import XCloseModalButton from '../../components/XCloseModalButton.vue'
import XDumbPagination from '../../components/XDumbPagination.vue'
import XModal from '../../components/XModal.vue'
import XTable from '../../components/XTable.vue'
import { handleGeneralXhrError } from '../../helpers'
import PaginationMixin from '../../mixins/PaginationMixin'
export default {
  components: { XModal, XCloseModalButton, XTable, XDumbPagination },
    computed: {
        modalTitle() {
            return _.get(this.role, 'label', '')
        },
    },
    data() {
        return {
            isLoading: false,
            meta: null,
            users: [],
        }
    },
    methods: {
        fetchUsers(page = 1) {
            this.isLoading = true
            const request = axios.get('/api/users', {
                params: {
                    order_by: 'name',
                    order_type: 'asc',
                    page,
                    user_role_ids: [
                        this.role?.id
                    ].filter(value => Boolean(value)),
                }
            }).then(response => {
                this.users = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleModalShown() {
            this.fetchUsers()
        },
        paginate(page) {
            this.fetchUsers(page)
        },
    },
    mixins: [
        PaginationMixin,
    ],
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
        role: {
            type: Object,
            required: false,
            default: null,
        },
    },
}
</script>